<template>
    <div>
        <!--
            This component combines all of the wireframes below.
            This allows for a unified initialization and usage of Velt (velt.dev) within the application.
            VeltComments are loaded directly from the SDK whereas the other wireframes are loaded from the components below.
        -->
        <collaboration-wireframes />
        <listen-comments-wireframes />
        <velt-comments
            resolved-comments-on-dom="true"
            comment-pin-highlighter="false"
            dialog-on-hover="false"
            popover-mode="true"
            shadow-dom="false"
            dialog-shadow-dom="false"
            popover-triangle-component="false"
            ghost-comments-indicator="false"
            text-mode="false"
            enter-key-to-submit="true"
            paginated-contact-list="true"
            :pin-cursor-image="pinCursorImage" />
    </div>
</template>

<script>
import CollaborationWireframes from '@/collaboration/wireframes/collaboration-wireframes.vue';
import ListenCommentsWireframes from '@/voc/components/comments/listen-comments-wireframes.vue';
import { pinCursorImage } from '@/collaboration/collaboration-mouse-cursor';
import { getCommentElement } from '../collaboration.utils';

export default {
    name: 'CollaborationIntegration',
    components: {
        CollaborationWireframes,
        ListenCommentsWireframes,
    },
    data () {
        return {
            veltCommentElement: null,
            boundCompositionStart: null,
            boundCompositionEnd: null,
            pinCursorImage,
        };
    },
    async mounted () {
        this.veltCommentElement = await getCommentElement();

        this.boundCompositionStart = this.beginComposition.bind(this);
        this.boundCompositionEnd = this.endComposition.bind(this);

        window.addEventListener('compositionstart', this.boundCompositionStart);
        window.addEventListener('compositionend', this.boundCompositionEnd);
    },
    unmounted () {
        window.removeEventListener('compositionstart', this.boundCompositionStart);
        window.removeEventListener('compositionend', this.boundCompositionEnd);
    },
    methods: {
        beginComposition () {
            this.veltCommentElement.disableEnterKeyToSubmit();
        },
        endComposition () {
            this.veltCommentElement.enableEnterKeyToSubmit();
        },
    },
};
</script>
